// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/TesteMemcached_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /debug/teste_memcached/delete
 *
 * Deletes a memcached key (debug-only endpoint).
 */
import { registerContract } from './validate'

export interface TesteMemcached_DeleteInput {
key: string
}

registerContract('TesteMemcached_DeleteInput', {
  key: { type: 'string',  required: true },
})
